import React, {useState, useEffect} from 'react';
import {classNames} from 'primereact/utils';
import {useAppSelector} from "../../../redux/hooks";
import SIPCallComponent from "../../JsSip";
import {DEV, STAGE} from "../../../redux/config";
import {useEffectiveOnlineStatus} from "../../../utils/internetReachability";
import {downloadBothUserConsoleLogs} from "../../../utils/userConsoleLogs";

const ProfileMenu = (props: any) => {
    const isOnline = useEffectiveOnlineStatus();
    const monitoringHubError = useAppSelector(state => state.WebRTCReducer.monitoringHubError);
    const statusHubError = useAppSelector(state => state.WebRTCReducer.statusHubError);
    const userDataHubError = useAppSelector(state => state.WebRTCReducer.userDataHubError);
    const dialerHubError = useAppSelector(state => state.WebRTCReducer.dialerHubError);
    const autoReload = useAppSelector(state => state.MonitoringListReducer.autoReload);
    const hash = window.location.hash;
    const [microphoneAccess, setMicrophoneAccess] = useState('unknown');
    const errorJsSip = useAppSelector(state => state.WebRTCReducer.errorJsSip);
    const errorJsSipTab = useAppSelector(state => state.WebRTCReducer.errorJsSipTab);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [reportStatus, setReportStatus] = useState<'idle' | 'empty' | 'downloaded'>('idle');

    interface NetworkInformation extends EventTarget {
        downlink: number;
        effectiveType: string;
    }

    const connection = (navigator as any).connection as NetworkInformation | undefined;
    const [networkInfo, setNetworkInfo] = useState({
        downlink: connection?.downlink ?? null,
        effectiveType: connection?.effectiveType ?? null
    });

    const getSignalStrength = (online: boolean, downlink: number | null, effectiveType: string | null): number => {
        if (!online) return 0;
        if (effectiveType === '3g') return 1;
        if ((effectiveType === 'slow-4g' || effectiveType === '4g') && downlink && downlink < 2.5) return 2;
        if (effectiveType === '4g' && downlink && downlink >= 2.5 && downlink && downlink <= 9) return 3;
        if (effectiveType === 'lte' || effectiveType === '5g' || (downlink && downlink >= 9)) return 4;
        return 1;
    };

    useEffect(() => {
        const updateNetworkInfo = () => {
            setNetworkInfo({
                downlink: connection?.downlink ?? null,
                effectiveType: connection?.effectiveType ?? null
            });
        };

        updateNetworkInfo();

        window.addEventListener('online', updateNetworkInfo);
        window.addEventListener('offline', updateNetworkInfo);
        connection?.addEventListener('change', updateNetworkInfo);

        const intervalId = setInterval(() => {
            updateNetworkInfo();
        }, 3000);

        return () => {
            window.removeEventListener('online', updateNetworkInfo);
            window.removeEventListener('offline', updateNetworkInfo);
            connection?.removeEventListener('change', updateNetworkInfo);
            clearInterval(intervalId);
        };
    }, [connection]);

    useEffect(() => {
        const checkMicrophoneAccess = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                setMicrophoneAccess('granted');
                stream.getTracks().forEach(track => track.stop());
            } catch (error: any) {
                if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                    setMicrophoneAccess('denied');
                } else {
                    setMicrophoneAccess('prompt');
                }
            }
        };
        checkMicrophoneAccess();
    }, []);

    useEffect(() => {
        if (reportStatus === 'idle') {
            return;
        }
        const timer = setTimeout(() => setReportStatus('idle'), reportStatus === 'empty' ? 1600 : 800);
        return () => clearTimeout(timer);
    }, [reportStatus]);

    const reportButtonLabel = () => {
        if (reportStatus === 'empty') {
            return 'Немає записів';
        }
        if (reportStatus === 'downloaded') {
            return 'Файли завантажено';
        }
        return 'Завантажити звіт помилок';
    };

    const downloadReport = () => {
        setReportStatus(downloadBothUserConsoleLogs(user?.userName) ? 'downloaded' : 'empty');
    };

    const signalStrength: any = getSignalStrength(isOnline, networkInfo.downlink, networkInfo.effectiveType);
    let strengthClass = '';

    switch (signalStrength) {
        case 1:
            strengthClass = 'weak';
            break;
        case 2:
            strengthClass = 'weak';
            break;
        case 3:
            strengthClass = 'medium';
            break;
        case 4:
            strengthClass = 'strong';
            break;
        default:
            strengthClass = 'signal-icon-offline';
            break;
    }

    return (
        <div className={classNames(
            'layout-rightmenu right-phone-block pt-0 flex flex-column',
            {
                'profile-menu-dev': DEV,
                'profile-menu-stage': STAGE,
                'layout-rightmenu-active': props.profileMenuActive,
            }
        )} style={{zIndex: '1103', paddingTop: '2rem'}}>
            {/*<div className="layout-inline-menu m-0 mt-2" style={{maxWidth: '270px'}} onClick={() => {*/}
            {/*    dispatch(getUserDetails(user.userId, jwtToken?.jwtToken, true));*/}
            {/*    if (hasUsersManagerUpdatePermission) {*/}
            {/*        dispatch(setEditType(true));*/}
            {/*    } else {*/}
            {/*        dispatch(setEditType(false));*/}
            {/*    }*/}
            {/*}}>*/}
            {/*    <ul className="layout-inline-menu-action-panel m-0">*/}
            {/*        <li className="layout-inline-menu-action-item m-0">*/}
            {/*            <button className="p-link pl-2">*/}
            {/*                <i className="pi pi-cog pt-1 text-xl" style={{paddingLeft: '2px'}}></i>*/}
            {/*                <span className="text-xl" style={{wordBreak: "break-all"}}>редагувати профіль</span>*/}
            {/*            </button>*/}
            {/*        </li>*/}
            {/*    </ul>*/}
            {/*</div>*/}
            <button onClick={() => props.profileMenuActiveChange(false)} className="layout-rightmenu-close p-link block">
                <i className="pi pi-times"></i>
            </button>
            {/*<div className="user-detail-wrapper pb-0 mb-4 pt-0">*/}
            {/*    <div className="user-detail-content mb-0">*/}
            {/*        <InternetStatus/>*/}
            {/*        {activeTab ?*/}
            {/*            <Button icon="pi pi-phone"  className="text-xl phone-icon outline-none shadow-none border-none cursor-pointer p-button-success text-white mr-2 border-circle ml-2" style={{backgroundColor: 'rgb(76, 175, 80)', width: '40px', height: '40px', fontSize: '40px'}}></Button>*/}
            {/*            : <Button icon="pi pi-phone"  className="text-xl phone-icon outline-none shadow-none cursor-pointer p-button-success text-white mx-2 border-circle relative overflow-visible flex justify-content-center ml-2" style={{backgroundColor: '#b3bac5', width: '40px', height: '40px', fontSize: '40px', border: '1px solid red'}} onClick={clickActive}><i className="offline-icon-phone pi pi-times"></i>*/}
            {/*            </Button>}*/}
            {/*        <div className="user-detail-content-right">*/}
            {/*            {userStatusObj && userStatusObj?.statusColor && <div className="flex p-0" style={{minWidth: '160px'}}>*/}
            {/*                <Badge onClick={handleBadgeClick} value={getStatusNameById(userStatusObj?.statusesId)} className={`${statusClass} text-white customer-badge px-2 text-xs p-0 cursor-pointer`} style={{borderRadius: '6px 0 0 6px', backgroundColor: `${userStatusObj?.statusColor}`}}/>*/}
            {/*                <div className="status-selector">*/}
            {/*                    <Dropdown*/}
            {/*                        ref={dropdownRef}*/}
            {/*                        value={userStatusObj?.statusesId}*/}
            {/*                        options={filteredStatusList}*/}
            {/*                        onChange={handleStatusChange}*/}
            {/*                        filter*/}
            {/*                        height={300}*/}
            {/*                        showClear*/}
            {/*                        panelClassName="statusNamePanel statusName"*/}
            {/*                        optionLabel="statusName"*/}
            {/*                        optionValue="id"*/}
            {/*                        style={{borderRadius: '0 6px 6px 0', borderColor: userStatusObj?.statusColor}}*/}
            {/*                        className={classNames(`statusName`, {'p-inputtext-filled h-full shadow-none': userStatusObj})}*/}
            {/*                        itemTemplate={customItemTemplate}*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*            </div>}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="layout-inline-menu m-0 mt-2">*/}
            {/*        <ul className="layout-inline-menu-action-panel m-0">*/}
            {/*            <li className="layout-inline-menu-action-item m-0">*/}
            {/*                <button className="p-link">*/}
            {/*                    <i className="pi pi-user pi-fw"></i>*/}
            {/*                    <span className="text-xl" style={{wordBreak: "break-all"}}>{user?.userName || 'Unknown'}</span>*/}
            {/*                </button>*/}
            {/*            </li>*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="mt-4">
                <SIPCallComponent statusHubConnectionState={props.statusHubConnectionState} profileMenuPinChange={props.onRightMenuPinChange} profileMenuActiveChange={props.profileMenuActiveChange}/>
            </div>
            <div className="flex flex-column mt-auto" style={{marginBottom: '100px'}}>
                {(!isOnline || strengthClass === 'weak') && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">Нестабільне інтернет з'єднання.</span>
                            </button>
                        </li>
                    </ul>
                </div>}
                {(errorJsSip || errorJsSipTab) && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">SIP підключення не активно</span>
                            </button>
                        </li>
                    </ul>
                </div>}
                <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button
                                type="button"
                                className="p-link"
                                onClick={downloadReport}
                            >
                                <i className="pi pi-download pi-fw"></i>
                                <span className="text-lg">{reportButtonLabel()}</span>
                            </button>
                        </li>
                    </ul>
                </div>
                {monitoringHubError && hash === '#/monitoring' && autoReload &&
                    <div className="layout-inline-menu m-0 mb-4 w-full">
                        <ul className="layout-inline-menu-action-panel m-0">
                            <li className="layout-inline-menu-action-item m-0">
                                <button className="p-link">
                                    <i style={{color: "red"}} className="pi pi-info-circle pi-chart-bar"></i>
                                    <span className="text-lg">Помилка підключення monitoringHub.</span>
                                </button>
                            </li>
                        </ul>
                    </div>}
                {statusHubError && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">Помилка підключення statusHub.</span>
                            </button>
                        </li>
                    </ul>
                </div>}
                {userDataHubError && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">Помилка підключення userDataHub.</span>
                            </button>
                        </li>
                    </ul>
                </div>}
                {dialerHubError && hash === '#/companies' && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">Помилка підключення dialerHub.</span>
                            </button>
                        </li>
                    </ul>
                </div>}
                {microphoneAccess !== 'granted' && <div className="layout-inline-menu m-0 mb-4 w-full">
                    <ul className="layout-inline-menu-action-panel m-0">
                        <li className="layout-inline-menu-action-item m-0">
                            <button className="p-link">
                                <i style={{color: "red"}} className="pi pi-info-circle pi-fw"></i>
                                <span className="text-lg">Дзвінки недоступні.
Відсутній доступ до мікрофона.</span>
                            </button>
                        </li>
                    </ul>
                </div>}
            </div>
        </div>
    );
};

export default ProfileMenu;
